<script lang="ts" setup>
  import Toast from 'primevue/toast';
</script>

<template>
  <Toast>
    <template #container="{ message, closeCallback }">
      <div
        class="w-256 rounded flex py-8 px-16 shadow text-white mb-8"
        :class="{
          'bg-blue': message.severity == 'info',
          'bg-green': message.severity == 'success',
          'bg-red': message.severity == 'error',
        }"
        @click="closeCallback">
        <div>{{ message?.summary }}</div>
        <div>{{ message?.details }}</div>
      </div>
    </template>
  </Toast>
</template>
